import { useState } from 'react'

import gradient from 'random-gradient'
import './App.css'

const data = [
  'Pay attention to who you are listening to the most during groupworks. Why is this?',
  'Pay attention to who is doing the extras in your group. For example, who takes notes during group discussions.',
  'Pay attention to who is most interrupted when talking. ',
  'Validate others by listening closely and believing the truth and importance of what they are sharing. ',
  'When you are in a group, pay attention when you get distracted, who is speaking?',
  'Pinpoint your top 5 online contacts this last month. How similar are they to you? ',
  'Identify 3 people you look up to. How are they similar to you? ',
  'When you are in a group work, notice whose names are most likely to be said aloud and whose names are not. What is the difference between these 2 people? ',
  'Do a scan of your LinkedIn. What proportion of your network is racialized versus white? ',
  'Count how many times you hear the word ‘Guys’ today. For each one, we invite you to list an alternative. ',
  'Think about people who have inspired you in your field of expertise. How similar are they to you? ',
  'Think about people who challenge your viewpoints. Do you take their insights into account?',
  'In a group work, play the observer role and analyse the behaviour of the other people. Are they all at ease? If not, why?',
  'Think of one biased statement you may have heard these past weeks. Suggest two questions you can ask to interrupt this bias next time you hear it.',
  'Notice yourself making a judgment and ask yourself the reason for this thought or action. ',
  'Think about different actions you could take to advance equity on campus. ',
  'Our ‘Cultural Glasses’, our opinions, and perception of others are often based on our past experiences. Reflect on what elements of your identity and your past experiences shape your ‘cultural glasses.',
  'What competencies and skills do I have to contribute to diversity and equality efforts? Once identified, its time to put them into practice!',
  'Today is your day off. We recommend the best-selling book by Robin DiAngelo, White Fragility. This book might help you to challenge and explore your assumptions about race.',
  'Analyse who are the authors of the readings professors provide you with. Do you consider there to be diverse authors? (Gender, race, culture...). If not, can course topics and content be adjusted to diversity and inclusion?',
  'Let’s talk about power and identities. Are there any existing power dynamics among your peers? Reflect on whether these impact on equality in the class. ',
  'Examine the skillsets of one of your teams. When you read them, who or what groups of people spring to mind first? Who doesnt have a good image ? ',
  'Think about different actions you could take to fight discrimination on campus.',
  'Ask your peers for feedback on how you handle inclusion in group works',
  'Who do you know the least in your team? How are they different from you? How does this difference impact the level of comfort? ',
  'Look at how performance is evaluated in your team. How might bias impact how people are scored? ',
  'Reflect on how a great leader looks to you.Does this person break the conventional standards associated with leadership?',
  'Brainstorm with your peers potential strategies to confront biased statements. Can you find a respectful and non confrontational way to flag them? ',
  'Notice which area of DEI you feel most uncomfortable with and think about 3 action points that could help you acquire deeper knowledge. ',
  'List out 3 actions you could do when witnessing a discriminatory situation.'
]

function App() {

  const today = new Date();

  //TODO Aanpassen naar: today.getUTCDate()
  const dayIndex = today.getUTCDate();
  const bgGradient = { background: gradient(today.toDateString()) }

  const [state, setstate] = useState(dayIndex - 1)

  return (
    <div className="App" style={bgGradient}>
      <div className="center">
        <h1 className="title">{`Vlerick DEI challenge is over`}</h1>
        <h2 className="quote">Time for making this challenge yours!</h2>
        {/* <div className="btngroup">
          <button className="button-30" onClick={() => setstate(state === 0 ? 0 : state - 1)} >Prev</button>
          <button className="button-30 right" onClick={() => setstate((state + 1) % data.length)} >Next</button>
        </div> */}
      </div>
    </div>
  );
}

export default App;
